"use strict";

exports.__esModule = true;
exports.AreaChartSeries = AreaChartSeries;
var _react = _interopRequireDefault(require("react"));
var _polished = require("polished");
var _d3Shape = require("d3-shape");
var _useUiDesign2 = require("../../Theme/UiDesign/useUiDesign");
var _excluded = ["width", "color", "height", "series", "xScale", "yScale", "curve"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var curveDict = {
  linear: _d3Shape.curveLinear,
  step: _d3Shape.curveStep,
  stepBefore: _d3Shape.curveStepBefore,
  stepAfter: _d3Shape.curveStepAfter,
  basis: _d3Shape.curveBasis,
  cardinal: _d3Shape.curveCardinal,
  monotoneX: _d3Shape.curveMonotoneX,
  catmullRom: _d3Shape.curveCatmullRom
};
var getCurve = function getCurve(nameOrImpl) {
  if (typeof nameOrImpl === "function") {
    return nameOrImpl;
  }
  return curveDict[nameOrImpl];
};
var makeStrokeColor = (0, _polished.darken)(0.2);

/**
 * Displays an Area chart series.
 */
// eslint-disable-next-line no-shadow
function AreaChartSeries(props) {
  var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
    modern = _useUiDesign.modern;
  var width = props.width,
    _props$color = props.color,
    color = _props$color === void 0 ? "steelblue" : _props$color,
    height = props.height,
    series = props.series,
    xScale = props.xScale,
    yScale = props.yScale,
    _props$curve = props.curve,
    curve = _props$curve === void 0 ? "linear" : _props$curve,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var data = series.data,
    getXValue = series.getXValue,
    getYValue = series.getYValue;
  var fillColor = typeof color === "function" ? color(data[0]) : color;
  var strokeColor = makeStrokeColor(fillColor);
  var points = (0, _d3Shape.area)().curve(getCurve(curve)).x(function (item) {
    return xScale(getXValue(item));
  }).y0(yScale(0)).y1(function (item) {
    return yScale(getYValue(item));
  });
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: width,
    height: height
  }, extra), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fillColor,
    stroke: strokeColor,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: modern ? "1.5" : "1",
    d: points(data)
  }));
}